import { safePolygon, useHover } from "@floating-ui/react";
import { isArray, isNumber } from "lodash-es";
import { useMemo } from "react";
export const useHoverController = ({ context, delay, hoverable, interactive }) => {
    const delayValue = useMemo(() => {
        if (isNumber(delay))
            return delay;
        if (isArray(delay))
            return {
                close: delay.at(0),
                open: delay.at(1),
            };
        return 500;
    }, [delay]);
    return useHover(context, {
        enabled: hoverable,
        delay: delayValue,
        handleClose: interactive ? safePolygon() : undefined,
    });
};
